import { Heart, ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

const PAYMENT_LINK = "https://checkout.nomba.com/payment-link/4526933226";

export const DonateNow = () => {
  return (
    <div data-testid="donate-now-page">
      {/* Hero */}
      <section className="relative overflow-hidden py-20 md:py-28 text-white">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/assets/hero-partner.png')" }}
        />
        <div className="absolute inset-0 bg-stone-900/70" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 z-10">
          <p className="font-accent text-xl text-amber-400 mb-3">Donate Now</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold mb-4">
            Make Your Impact Today
          </h1>
          <p className="text-lg text-stone-200 max-w-3xl">
            Your donation helps GLGIF deliver relief, education, empowerment, and protection
            to vulnerable communities.
          </p>
        </div>
      </section>

      {/* Donate Card */}
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Card className="border-stone-200 shadow-sm">
            <CardHeader>
              <CardTitle className="font-heading text-2xl flex items-center gap-3">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                  <Heart className="w-6 h-6 text-green-700" />
                </div>
                Support GLGIF
              </CardTitle>
            </CardHeader>

            <CardContent className="space-y-6">
              <p className="text-stone-700 leading-relaxed">
                Click the button below to continue to our secure donation payment page.
              </p>

              <a
                href={PAYMENT_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
                data-testid="donate-pay-link"
              >
                <Button
                  type="button"
                  className="w-full bg-green-700 hover:bg-green-800 text-white rounded-full py-6"
                >
                  Pay Now
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </a>

              <div className="text-center">
                <p className="text-sm text-stone-500 mb-2">
                </p>
                <Link
                  to="/"
                  className="text-sm font-medium text-amber-700 hover:text-amber-800 underline underline-offset-4"
                  data-testid="donate-back-home"
                >
                  Back to Home
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default DonateNow;
